import React from 'react';

//Components
import GenericHeader from '../../../../common/pageHeader/GenericHeader';
import Text from '../../../../common/form/Text';
import Button from '../../../../common/button/Button';
import { INPUT_TYPES } from '../../../../common/form/constants/fieldTypes';

export const RenderNoRecordFound = ({ clearData, startNewApplication }) => {
    return(
        <div className='gi-panel desktop:grid-col-fill tablet:grid-col-fill mobile-lg:grid-col-12 grid-col-12' id="ede-search-result__found-records">
            <div className="member__name margin-l-20">
                <GenericHeader
                    id='header'
                    text='selfDesignation.search.searchResult.modal.header.noMatchFound'
                    tag='h3'
                    headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}

                />
            </div>
            <div className='grid-row flex-row grid-offset-1' id='ede-search-result__member-info'>
                <Text
                    id='no_result_message'
                    text='selfDesignation.search.searchResult.modal.message.noMatchFound'
                    display='block'
                />
            </div>
            <div className='grid-col-12 action__btn__wrapper'>
                <Button
                    { ...{
                        id:'clear-btn',
                        name:'clearBtn',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'margin-r-10', 'display-inline'],
                        classes:['gi-button__secondary'],
                        btnText:'selfDesignation.search.action-btn.cancel',
                        handleClick: clearData
                    }}

                />
                <Button
                    { ...{
                        id:'start-new-app-btn',
                        name:'startNewApplicationBtn',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'display-inline'],
                        classes:['gi-button__primary'],
                        btnText:'selfDesignation.search.action-btn.startNewApplication',
                        handleClick: startNewApplication
                    }}

                />
            </div>
        </div>
    );
};